module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 9.5caca6bf.png";